module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"hooks.onStopInit":[{"value":function () {
var routes = this.getOption('mapMember.routes');
if (fox.site.getEnv('siteProps.aboutMeDisabled')== 1) {
routes['about'] = '>>'
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/app.opt
// module id = 679
// module chunks = 4